import { type CdkTree, CdkTreeModule } from '@angular/cdk/tree';
import { Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import type { DynamicFlatNode, IChannelGroup } from 'commons';
@Component({
  selector: 'dtis-simple-expandable-tree-entity',
  imports: [MatIconModule, MatButtonModule, CdkTreeModule],
  template: `
    <div class="flex w-full items-center gap-2">
      @if (node().entity.channels.length > 0) {
      <button
        [id]="'toggleDatasourceTreeEntity-' + node().id"
        cdkTreeNodeToggle
        mat-icon-button
        [attr.aria-label]="'Toggle ' + node().label"
      >
        <mat-icon class="mat-icon-rtl-mirror">
          {{ tree().isExpanded(node()) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      }@else {
      <button mat-icon-button disabled>
        <mat-icon class="mat-icon-rtl-mirror">
          {{ 'chevron_right' }}
        </mat-icon>
      </button>
      }
      <span
        cdkTreeNodeToggle
        class="text-body-large cursor-pointer overflow-hidden whitespace-nowrap antialiased"
        data-cy="dtis-tree-datasource-label"
      >
        {{ node().label }}
      </span>
    </div>
  `,
})
export class DtisSimpleExpandableTreeEntityComponent {
  readonly node = input.required<DynamicFlatNode<IChannelGroup>>();
  readonly tree = input.required<CdkTree<DynamicFlatNode>>();
}
